import type { UserRole } from '@vmt/shared';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { FullPageSpinner } from '../components/ui/Spinner';
import { EmptyState } from '../components/ui/EmptyState';
import { useAuth } from './AuthProvider';

/** Guards a route: guests are sent to the login, users without the role see a notice. */
export function RequireRole({ role, children }: { role: UserRole; children: ReactNode }) {
  const { status, can } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <FullPageSpinner />;
  if (status === 'guest') {
    return (
      <Navigate
        to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }
  if (!can(role)) {
    return (
      <EmptyState
        title="Keine Berechtigung"
        description="Für diese Seite fehlen dir die nötigen Rechte."
      />
    );
  }
  return <>{children}</>;
}
